import React, { useMemo, useState } from "react";
import { createRoot } from "react-dom/client";

import {
  ApolloProvider,
  ApolloClient,
  ApolloLink,
} from "shared/providers/apollo/apollo.package";
import apolloCache from "./common/apollo/cache";
import apolloHttpLink from "./common/apollo/http-link";
import apolloAuthLink from "./common/apollo/auth-link";
import apolloErrorLink from "./common/apollo/error-link";

import StylesProvider from "shared/providers/styles.provider";
import RouterProvider from "shared/providers/router/router.provider";
import DayjsProvider from "shared/providers/dayjs/dajys.provider";
import I18Provider from "shared/providers/i18next/i18next.provider";

import { App } from "./components/app";

import initSentry from "shared/providers/sentry/init";
import initI18next from "shared/utils/i18next/init";
import reportWebVitals from "./reportWebVitals";

initSentry(
  process.env.REACT_APP_SENTRY_DSN || "",
  process.env.NODE_ENV || "development",
  process.env.REACT_APP_GQL_URL || ""
);

initI18next();

const RootComponent = () => {
  const [isMaintenance, setIsMaintenance] = useState(false);

  const apolloClient = useMemo(
    () =>
      new ApolloClient({
        link: ApolloLink.from([
          apolloErrorLink(setIsMaintenance),
          ApolloLink.from([apolloAuthLink, apolloHttpLink]),
        ]),
        cache: apolloCache,
      }),
    []
  );

  return (
    <React.StrictMode>
      <StylesProvider>
        <I18Provider>
          <ApolloProvider client={apolloClient}>
            <RouterProvider>
              <DayjsProvider>
                <App isMaintenance={isMaintenance} />
              </DayjsProvider>
            </RouterProvider>
          </ApolloProvider>
        </I18Provider>
      </StylesProvider>
    </React.StrictMode>
  );
};

const root = createRoot(document.getElementById("app")!);

root.render(<RootComponent />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
